import { TypeOurPeopleWithoutUnresolvableLinksResponse } from '@/features/contentful/_generated';

export const sortPeople = (
    people: TypeOurPeopleWithoutUnresolvableLinksResponse[],
): TypeOurPeopleWithoutUnresolvableLinksResponse[] => {
    return people.sort((a, b) => {
        const aOrder = parseInt(a.fields.order, 10);
        const bOrder = parseInt(b.fields.order, 10);

        if (aOrder < bOrder) {
            return -1;
        }

        if (aOrder > bOrder) {
            return 1;
        }

        return 0;
    });
};
